function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-105.344-47.889a.754.754,0,0,0,.666-.833.755.755,0,0,0-.833-.666l-10.4,1.156h0l-10.414,1.157a.754.754,0,0,0-.666.833.754.754,0,0,0,.749.671.761.761,0,0,0,.084,0l9.572-1.063V-44.5H-123.3a.754.754,0,0,0-.617.321,13.672,13.672,0,0,0-2.5,7.9,13.672,13.672,0,0,0,2.5,7.9.754.754,0,0,0,.617.321h14.935a.754.754,0,0,0,.617-.321,13.672,13.672,0,0,0,2.5-7.9,13.672,13.672,0,0,0-2.5-7.9.754.754,0,0,0-.617-.321h-6.713v-2.3Zm-13.472,4.895h2.225v13.426h-2.225Zm-4.089,0h2.58v5.959h-4.555A12.212,12.212,0,0,1-122.9-42.994Zm-1.975,7.467h4.555v5.959h-2.58A12.212,12.212,0,0,1-124.88-35.527Zm16.111,5.959h-2.58v-5.959h4.555A12.212,12.212,0,0,1-108.769-29.568Zm1.975-7.467h-4.555v-5.959h2.58A12.212,12.212,0,0,1-106.794-37.035Zm-6.064-5.959v13.426h-2.225V-42.994Z",
  transform: "translate(127 49.393)",
  fill: "#fff"
});

var SvgRopeways = function SvgRopeways(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ropeways",
    className: "fill",
    width: 22.327,
    height: 21.333,
    viewBox: "0 0 22.327 21.333",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRopeways, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ropeways.dd79bd99.svg";
export { ForwardRef as ReactComponent };